import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const wrap: CSSObject = {
  display: 'flex',
  height: '100vh',
  '@supports (height: 100dvh)': {
    height: '100dvh',
  },
  background: theme.color.background,
};

const body: CSSObject = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
};

const contents: CSSObject = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
};

const contentsWrap: CSSObject = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  background: theme.color.background,
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch',
  '> div': {
    width: '100%',
    maxWidth: 1440,
    margin: '0 auto',
    padding: '28px 32px 48px',
    boxSizing: 'border-box',
  },
  [mobile]: {
    '> div': {
      padding: `0 16px calc(32px + env(safe-area-inset-bottom))`,
    },
  },
};

export { wrap, body, contents, contentsWrap };
